import styled from 'styled-components'
import { space, layout, color, flexbox, border, shadow, position, variant } from 'styled-system'
import propTypes from '@styled-system/prop-types'
import PropTypes from 'prop-types'

const CardDefault = styled.div(
  variant({
    variants: {
      dark: {
        bg: '#293450',
        color: '#fff'
      },
      orange: {
        bg: '#FF7708',
        color: '#fff'
      },
      light: {
        bg: '#fff',
        color: '#7f8c8d'
      }
    }
  }),
  {
    padding: '32px',
    borderRadius: '8px'
  },
  flexbox,
  space,
  layout,
  color,
  border,
  shadow,
  position
)
CardDefault.defaultProps = {
  variant: 'light'
}

CardDefault.propTypes = {
  variant: PropTypes.oneOf(['dark', 'orange', 'light']),
  ...propTypes.space,
  ...propTypes.layout,
  ...propTypes.color,
  ...propTypes.flexbox,
  ...propTypes.border,
  ...propTypes.shadow,
  ...propTypes.position
}

export { CardDefault }
